/* eslint-disable import/no-unresolved */
import { memo, useEffect, useState } from "react";
import { useFormik } from "formik";
import {
  // jointMemberInitialValues,
  jointMemberValidationSchema
} from "src/helpers/FormDetails/JointLifeAddendum";
import { useAppSelector } from "src/utils/hooks/useAppSelector";
import { existingLifeCoverInitialValuesObject } from "src/helpers/FormDetails/LoanDetails";
import { setJointPincodeData } from "src/redux/Actions/jointLifeAddendum";
import store from "src/redux/store";
import { setStepDetails } from "src/redux/Actions/common";
import { Button } from "@mui/material";
import CustomModal from "src/shared/CustomModal";
import CustomCheckBox from "src/shared/CustomCheckBox";
import { setJointMemberPostDetails } from "src/redux/Thunk";
import ConfirmationModal from "src/shared/ConfirmationModal";
import JointMemberDetails from "./JointMemberDetails";
import SecondaryDetails from "../../ProposerDetails/Address/SecondaryDetails";
import ExistingLifeCoverDetails from "../../LoanDetails/ExistingLifeCoverDetails";

function JoinLifeMember() {
  const mefSchema = useAppSelector((state): any => state.masterdata_reducer?.mefJourneySchema);
  const memberDetailsSchema = mefSchema?.memberDetailsSchema || {};
  const secondaryDetailsSchema = mefSchema?.secondaryDetailsSchema || {};
  const jointLifeMemberDetails = useAppSelector((state) => state.jointLifeAddendum.member);
  const jointLifeAddressDetails = useAppSelector((state) => state.jointLifeAddendum.address);
  const jointLifeExistingPolicyDetails = useAppSelector(
    (state) => state.jointLifeAddendum.existingPolicy
  );
  const isAddressProposer = useAppSelector((state) => state.jointLifeAddendum.isAddressProposer);
  const jointCoBorrowerFlag = useAppSelector(
    (state) => state.jointLifeAddendum.jointCoBorrowerFlag
  );
  const jointGuarantorFlag = useAppSelector((state) => state.jointLifeAddendum.jointGuarantorFlag);
  const jointPrimaryBorrowerFlag = useAppSelector(
    (state) => state.jointLifeAddendum.jointPrimaryBorrowerFlag
  );
  const jointHousewifeFlag = useAppSelector((state) => state.jointLifeAddendum.jointHousewifeFlag);
  const [existingPolicy, setExistingPolicy] = useState(jointLifeExistingPolicyDetails);
  const proposerAddressDetails = useAppSelector((state) => state.proposerDetails?.address?.address);
  const [isPinCodeInvalid, setIsPinCodeInvalid] = useState(false);
  const [modalOpen, setModalOpen] = useState<boolean>(false);
  const proposalStatus = useAppSelector((state) => state.proposalStatus.status);
  const parentStepNo = useAppSelector((state) => state.stepDetails?.parentStepNo);
  // const jointStepNo = useAppSelector((state) => state.stepDetails?.jointStepNo);
  const [changeModalOpen, setChangeModalOpen] = useState<boolean>(false);
  const [fieldName, setFieldName] = useState<string[]>([]);
  const generalDetailsData = useAppSelector((state: any) => state.generalDetails);
  const [formikJointHousewifeFlag, setFormikJointHousewifeFlag] = useState(jointHousewifeFlag);
  const { lifeAssuredDetails: { address } = {} as any } =
    useAppSelector((state): any => state.masterdata_reducer?.mefJourneySchema) || {};
  const partnerId = useAppSelector((state) => state?.common?.leadDetails?.partnerId);
  const productId = useAppSelector((state) => state.common?.productId);
  const leadId = useAppSelector((state) => state?.common?.leadId);
  const salutationSelector = (state: {
    masterdata_reducer: {
      salutationDetails: any;
    };
  }) => state.masterdata_reducer.salutationDetails;
  const salutationData = useAppSelector(salutationSelector);
  const formik = useFormik({
    enableReinitialize: true,
    validateOnMount: true,
    validateOnChange: true,
    validateOnBlur: true,
    initialValues: {
      member: jointLifeMemberDetails,
      address: jointLifeAddressDetails,
      existingPolicy: jointLifeExistingPolicyDetails,
      isAddressProposer,
      jointCoBorrowerFlag,
      jointGuarantorFlag,
      jointHousewifeFlag,
      jointPrimaryBorrowerFlag
    },
    validationSchema: jointMemberValidationSchema(
      isPinCodeInvalid,
      partnerId,
      formikJointHousewifeFlag,
      productId,
      memberDetailsSchema,
      salutationData,
      address
    ),
    onSubmit: (fieldValues) => {
      if (proposalStatus !== "MEF Submitted") {
        store.dispatch(setJointMemberPostDetails(leadId, fieldValues, { jointStepNo: 2 }));
        // store.dispatch(setJointMemberPostDetails(fieldValues, { jointStepNo: jointStepNo + 1 }));
        window.scrollTo(0, 0);
      }
    }
  });
  const handleCheckboxChange = (name: string) => {
    const otherCheckboxes = [
      "jointCoBorrowerFlag",
      "jointGuarantorFlag",
      "jointPrimaryBorrowerFlag"
    ].filter((checkbox) => checkbox !== name);
    otherCheckboxes.forEach((checkbox) => formik.setFieldValue(checkbox, false));
  };
  useEffect(() => {
    formik.setValues({
      member: jointLifeMemberDetails,
      address: jointLifeAddressDetails,
      existingPolicy: jointLifeExistingPolicyDetails,
      isAddressProposer,
      jointCoBorrowerFlag,
      jointGuarantorFlag,
      jointHousewifeFlag,
      jointPrimaryBorrowerFlag
    });
  }, []);

  useEffect(() => {
    formik.setFieldValue("existingPolicy", existingPolicy);
  }, [existingPolicy]);

  const handleExistingLifeCoverAddButton = () => {
    setExistingPolicy({
      ...formik.values.existingPolicy,
      existingPolicyDetails: [
        // eslint-disable-next-line no-unsafe-optional-chaining
        ...formik.values?.existingPolicy?.existingPolicyDetails,
        existingLifeCoverInitialValuesObject
      ]
    });
  };

  useEffect(() => {
    setFormikJointHousewifeFlag(formik.values.jointHousewifeFlag);
  }, [formik.values.jointHousewifeFlag]);

  const handleExistingLifeCoverRemoveButton = (existingCoverIndex: number) => {
    setExistingPolicy({
      ...formik.values.existingPolicy,
      existingPolicyDetails: formik.values?.existingPolicy?.existingPolicyDetails.filter(
        (_, index) => index !== existingCoverIndex
      )
    });
  };

  useEffect(() => {
    if (!formik.values.existingPolicy?.existingLifeCover) {
      setExistingPolicy({
        ...formik.values.existingPolicy,
        existingPolicyDetails: [existingLifeCoverInitialValuesObject]
      });
    }
  }, [formik.values.existingPolicy?.existingLifeCover]);

  const handleJointLifeAddendumForm = () => {
    const changedFields: string[] = [];
    const fieldsToCheck = ["gender", "firstName", "middleName", "lastName", "dob"];
    const fieldNameMap: { [key: string]: string } = {
      gender: "Gender",
      firstName: "First Name",
      middleName: "Middle Name",
      lastName: "Last Name",
      dob: "Date of Birth"
    };

    fieldsToCheck.forEach((field) => {
      const formattedFieldName = fieldNameMap[field as keyof typeof fieldNameMap] || field;
      const previousValue = jointLifeMemberDetails[field as keyof typeof jointLifeMemberDetails];
      const newValue = formik.values.member[field as keyof typeof formik.values.member];
      if (newValue !== previousValue) {
        changedFields.push(formattedFieldName);
      }
    });

    if (!formik.isValid || isPinCodeInvalid) {
      setModalOpen(true);
      setChangeModalOpen(false);
      formik.handleSubmit();
    } else if (changedFields.length > 0) {
      setFieldName(changedFields);
      setChangeModalOpen(true);
      setModalOpen(false);
    } else {
      store.dispatch(setJointMemberPostDetails(leadId, formik.values, { jointStepNo: 2 }));
      window.scrollTo(0, 0);
      formik.handleSubmit();
    }
  };

  const handlePincodeClick = (data: any) => store.dispatch(setJointPincodeData(data));

  const handleAddressChange = () => {
    if (formik.values?.isAddressProposer) {
      formik.setFieldValue("address", proposerAddressDetails);
    } else {
      formik.setFieldValue("address", jointLifeAddressDetails);
    }
  };
  useEffect(() => {
    handleAddressChange();
  }, [formik.values?.isAddressProposer]);
  useEffect(() => {
    if (formik.values.member.genderCode === "F" && formik.values.member.occupationCode === "HW") {
      formik.setFieldValue("jointHousewifeFlag", true);
      formik.setFieldValue("annualIncome", "");
    } else {
      formik.setFieldValue("jointHousewifeFlag", false);
    }
  }, [
    formik.values.member?.occupationCode,
    formik.values.member?.annualIncome,
    formik.values.member?.genderCode
  ]);
  return (
    <>
      <CustomModal modalOpen={modalOpen} setModalOpen={setModalOpen} />
      {changeModalOpen && (
        <ConfirmationModal
          text={
            <div>
              <p>
                The
                {fieldName.map((field, index) => (
                  <span key={field}>
                    <span className="text-mediumElectricBlue">{` ${field}`}</span>
                    {index !== fieldName.length - 1 ? "," : ""}
                  </span>
                ))}
                <span> </span>has been changed and additional proofs will be called for establishing
                the same.
              </p>
            </div>
          }
          onNext={() => {
            handleJointLifeAddendumForm();
            formik.values.member.requirementFlag = true;
            store.dispatch(setJointMemberPostDetails(leadId, formik.values, { jointStepNo: 2 }));
            window.scrollTo(0, 0);
            setChangeModalOpen(false);
          }}
          onCancel={() => {
            setChangeModalOpen(false);
          }}
        />
      )}
      <div className="pl-10.25 bg-white pr-10 py-8 rounded-b-1.5xl space-y-10">
        <div>
          <span className="font-montserrat text-black text-base font-bold mb-6 !my-auto">
            Details of Members to be Insured
          </span>
          <JointMemberDetails formik={formik} memberDetailsSchema={memberDetailsSchema} />
        </div>
        <div className="space-y-6">
          <span className="font-montserrat text-black text-base font-bold !my-auto">
            Secondary Details
          </span>
          <SecondaryDetails
            isAddressProposer={formik.values?.isAddressProposer}
            formik={{
              errors: formik.errors,
              values: formik.values,
              touched: formik.touched,
              formikHandlers: formik
            }}
            savePincodeDataToStore={handlePincodeClick}
            setIsPinCodeInvalid={setIsPinCodeInvalid}
            secondaryDetailsSchema={secondaryDetailsSchema}
          />
          <div className="mt-5 w-72">
            <CustomCheckBox
              label="Same As Proposer Address"
              name="isAddressProposer"
              handleBlur={formik.handleBlur}
              setFieldValue={formik.setFieldValue}
              checked={formik.values?.isAddressProposer}
            />
          </div>
          <div className="grid grid-cols-2 sm:grid-cols-3 max-w-[500px] my-5 sm:my-8">
            <div className="w-full">
              <CustomCheckBox
                // isReview
                label="Co-Borrower"
                name="jointCoBorrowerFlag"
                handleBlur={formik.handleBlur}
                setFieldValue={formik.setFieldValue}
                checked={formik.values?.jointCoBorrowerFlag}
                onChange={() => handleCheckboxChange("jointCoBorrowerFlag")}
              />
            </div>
            <div className="w-full">
              <CustomCheckBox
                isReview={generalDetailsData?.isGuarantor}
                label="Guarantor"
                name="jointGuarantorFlag"
                handleBlur={formik.handleBlur}
                setFieldValue={formik.setFieldValue}
                checked={formik.values?.jointGuarantorFlag}
                onChange={() => handleCheckboxChange("jointGuarantorFlag")}
              />
            </div>
            <div className="w-full">
              <CustomCheckBox
                isReview={
                  generalDetailsData?.isHousewife || formik.values.member.genderCode === "M"
                }
                label="Primary Borrower"
                name="jointPrimaryBorrowerFlag"
                handleBlur={formik.handleBlur}
                setFieldValue={formik.setFieldValue}
                checked={formik.values?.jointPrimaryBorrowerFlag}
                onChange={() => handleCheckboxChange("jointPrimaryBorrowerFlag")}
              />
            </div>
          </div>
        </div>
      </div>
      <div className="w-full" />
      <div className="pl-10.25 bg-white pr-10 py-4 rounded-1.5xl">
        <ExistingLifeCoverDetails
          formik={formik}
          existingLifeCoverLength={existingPolicy?.existingPolicyDetails?.length}
          handleExistingLifeCoverAddButton={handleExistingLifeCoverAddButton}
          handleExistingLifeCoverRemoveButton={handleExistingLifeCoverRemoveButton}
        />
      </div>
      <div className="mt-10 flex justify-center">
        <Button
          variant="outlined"
          classes={{ outlined: "!rounded-lg" }}
          onClick={() => {
            store.dispatch(setStepDetails({ parentStepNo: parentStepNo - 1 }));
            window.scrollTo(0, 0);
          }}
          className="!text-black !uppercase h-13 w-37.5 rounded-xl !mr-10"
        >
          Back
        </Button>
        <Button
          variant="contained"
          classes={{ contained: "!rounded-lg" }}
          onClick={handleJointLifeAddendumForm}
          className="!uppercase h-13 w-37.5"
        >
          NEXT
        </Button>
      </div>
    </>
  );
}

export default memo(JoinLifeMember);
